import ApiService from '@/core/services/api.service'

// action types
export const GET_COUNTRIES = 'getCountries'

// mutation types
export const SET_COUNTRIES = 'setCountries'

const state = {
  countries: {}
}

const getters = {
  countries(state) {
    return state.countries
  }
}

const actions = {
  async [GET_COUNTRIES](context) {
    let { data } = await ApiService.get(`countries`)
    context.commit(SET_COUNTRIES, data.data)
  },
}

const mutations = {
  [SET_COUNTRIES](state, payload) {
    state.countries = payload
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
